module.exports = __webpack_public_path__ + "static/img/09.6c50d62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/09.jpg
// module id = c+Mz
// module chunks = 1